export default function Spacing({ lg, md }) {
    return <div className={`cs_height_lg_${lg ?? ""} cs_height_md_${md ?? ""}`} />;
}